export const cellphoneValidator = (value: unknown) => {
  if (typeof value !== 'string') {
    return false;
  }
  const digits = value.replace(/\D/g, '');

  return (digits.length > 9);
};
